<template>
    <full-screen-overlay @close="exit" backTo="Model">

        <dashboard-header header="Upload model image" description="Select a compressed file of a Tensorflow Saved Model" />

         <div  class="w-full mt-8">
            <FormulateForm @submit="uploadModel" class="max-w-screen-xs" :values="model">
                <label class="text-sm text-gray-500 leading-8" for="file">Upload TAR or ZIP file of your Tensorflow saved model</label>

                <div class="h-24">
                     <FormulateInput
                        type="file"
                        name="file"
                        validation="mime:application/gzip,application/x-gzip,application/x-gtar,application/x-tgz,application/zip"
                        accept="application/gzip,application/x-gzip,application/x-gtar,application/x-tgz,application/zip"
                        upload-behavior="delayed"
                        :uploader="uploadFile"
                        required
                    />
                </div>

                <div class="w-full bg-primary bg-opacity-10 rounded-lg p-4 text-primary font-semibold space-y-2">
                    <p>Deploying a new model will add an additional ${{monthlyPrice}} monthly charge to your account. A free trial for the first 3 days is provided.</p>

                    <p class="text-sm font-normal">30 day money back guarantee if there are any issues.</p>

                    <div class="flex items-center">

                        <input id="remember_me" required type="checkbox" class="form-checkbox h-4 w-4 transition duration-150 ease-in-out">

                        <label for="remember_me" class="ml-2 block text-sm leading-5 font-normal">
                            I agree to this billing change
                        </label>
                    </div>

                </div>

                <base-button bgColor="bg-success dark:bg-green-600" borderColor="border-success" hoverBg="hover:bg-green-400 dark-hover:bg-green-500" hoverBorder="hover:border-success-400" class="mt-10" icon="model" iconPosition="left"   type="submit">Upload and deploy model</base-button>
            </FormulateForm>
        </div>

    </full-screen-overlay>
</template>

<script>
import { LayoutComponents } from '@/modules/Dashboard/components'
import { uploadedModelImage } from "@/graphql/mutations";
import { uploadModelImage } from "@/graphql/queries";
import { authenticationState, loading, error, currentProject } from '@/mixins';
import { BlockBlobClient } from "@azure/storage-blob";
import monthlyPricing from "@/data/monthly-pricing";

export default {
    name: "UploadModelImage",
    metaInfo: {
      title: 'Upload Model Image',
    },
    mixins: [LayoutComponents, authenticationState, loading, error, currentProject ],
    data () {
        return {
            isSubmitting: false,
            model: {},
            monthlyPrice: monthlyPricing['MODEL']
        }
    },
    methods: {
        exit () {
            this.$router.push({ name: 'ModelPage', params: { ...this.$route.params }, query: { ...this.$route.query } });
        },
        changeSelected (id) {
            this.selectedModel = id;
        },
        async uploadFile(file, progress, error, option) {
            this.$root.$emit('loading', true);
            try {
                const presignedUrlObject = await this.$apollo.query({
                    query: uploadModelImage,
                    variables: {
                        input: {
                            projectId: this.currentProjectId,
                            modelId: this.currentModelId
                        }
                    }
                });

                const presignedUrl = presignedUrlObject.data.uploadModelImage.presignedUrl
                const blockBlobClient = new BlockBlobClient(presignedUrl);
                
                await blockBlobClient.uploadBrowserData(file, { 
                    blobHTTPHeaders: { blobContentType: file.type },
                    onProgress: (function progress(event) {
                        this.markProgress(parseInt(event.loadedBytes / this.fileSize * 100));
                    }).bind({ fileSize: file.size, markProgress: progress })
                });

            } catch (error) {
                console.log('error', error)
                this.handleError(error);
            }
            this.$root.$emit('loading', false);
        },
        async uploadModel(data) {

            if (this.isSubmitting) {
                return
            }

            this.isSubmitting = true;

            try {
                this.$root.$emit('loading', true);

                await this.$apollo.mutate({
                    mutation: uploadedModelImage,
                    variables: {
                        input: {
                            projectId: this.currentProjectId,
                            modelId: this.currentModelId
                        }
                    }
                });

                this.exit()
            } catch (error) {
                this.handleError(error);
            }

            this.$root.$emit('loading', false);

            this.isSubmitting = false;
        }
    }
}
</script>